"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const semver_1 = require("semver");
const useQueryData_1 = require("./useQueryData");
const FETCH_SETTINGS = { cache: 'no-cache' };
const DEFAULT_BUILD = '1.0.0';
const DEFAULT_LANGUAGE = 'en_US';
const useLocalizedJsonWithManifest = (baseUrl, feature, manifestUrl, contentUrl, replacementToken = '%LOCALE%') => {
    const [gameLocale, gameLocaleHasError] = (0, useQueryData_1.default)('game', 'locale');
    const [locale, setLocale] = (0, react_1.useState)('');
    const semver = (0, useQueryData_1.default)('game', 'semver') || DEFAULT_BUILD;
    const [data, setData] = (0, react_1.useState)(null);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const [retryCount, setRetryCount] = (0, react_1.useState)(0);
    // Ensure we have a locale
    (0, react_1.useEffect)(() => {
        if (gameLocale !== null) {
            setLocale(gameLocale);
            return;
        }
        else if ((error && locale !== DEFAULT_LANGUAGE) || !gameLocale) {
            const timer = setTimeout(() => setLocale(DEFAULT_LANGUAGE), 5000);
            return () => clearTimeout(timer);
        }
    }, [error, gameLocale, locale]);
    // Grab the Manifest and then the Data
    (0, react_1.useEffect)(() => {
        if (locale) {
            let urlRoot = null;
            const getData = () => __awaiter(void 0, void 0, void 0, function* () {
                var _a, _b;
                try {
                    const response = yield fetch(`${baseUrl}/${manifestUrl}`, FETCH_SETTINGS);
                    const manifestData = yield response.json();
                    // Find all manifest entries that are valid for this build
                    const validVersions = manifestData.builds.filter((version) => {
                        return (0, semver_1.satisfies)(semver, version.semver);
                    });
                    // Sort the entries by the min version supported
                    const sortedVersions = validVersions.sort((a, b) => {
                        if ((0, semver_1.minVersion)(a.semver).version < (0, semver_1.minVersion)(b.semver).version) {
                            return -1;
                        }
                        else {
                            return 1;
                        }
                    });
                    urlRoot = (_b = (_a = sortedVersions === null || sortedVersions === void 0 ? void 0 : sortedVersions[sortedVersions.length - 1]) === null || _a === void 0 ? void 0 : _a.root) !== null && _b !== void 0 ? _b : manifestData.builds.filter((version) => version.semver === '1.x.x')[0].root;
                }
                catch (error) {
                    urlRoot = `${baseUrl}/${feature}/default/`;
                }
                const url = `${urlRoot}${contentUrl}`.replace(replacementToken, locale);
                setLoading(true);
                setError(null);
                fetch(url, FETCH_SETTINGS)
                    .then((data) => data.json())
                    .then(setData)
                    .catch((err) => {
                    setError(err);
                    setData(null);
                })
                    .finally(() => {
                    setLoading(false);
                });
            });
            getData();
        }
    }, [locale]);
    const retry = (0, react_1.useCallback)(() => {
        if (!loading) {
            setRetryCount((x) => x + 1);
        }
    }, [loading]);
    return [data, loading, error !== null && error !== void 0 ? error : gameLocaleHasError, retry, retryCount];
};
exports.default = useLocalizedJsonWithManifest;
